const vehicleAlarm = {
  overspeedRule: {
    ruleName: '规则名称',
    carCount: '规则内车辆数',
    createdOn: '规则创建时间',
    add: '新增规则',
    edit: '编辑规则',
    carList: '车辆列表',
    errorName: '请输入规则名称',
    errorSpeed: '请输入最大车速(合法数字)',
    bound: '已绑定',
    unbound: '未绑定',
    ruleCar: '已设规则的车辆信息',
    noRuleCar: '未设规则的车辆信息',
    addCar: '添加车辆',
    deleteCar: '删除车辆',
    subUserTip: "您可以创建一个超速报警规则给您的"
  },
  overspeedRecord: {
    alarmTime: '报警时间',
    ruleName: '规则名称',
    startAddress: '开始地点',
    endAddress: '结束地点',
    startSpeed: '开始车速(km/h)',
    endSpeed: '结束车速(km/h)',
  },
  maxSpeed: '最大车速(km/h)',
  remark: '备注'
}
export default vehicleAlarm